import handleEvent from 'utilities/handleEvent';

import styles from './styles.module.scss';

const handleClick = onClick => handleEvent(onClick);

const ButtonLink = ({ className = '', href, isActived, onClick, text }) => {
    return href ? (
        <a
            className={`${className} ${styles.buttonLink} ${
                isActived ? styles.activedStyle : ''
            }`}
            href={href}
        >
            {text}
        </a>
    ) : (
        <button
            className={`${className} ${styles.buttonLink} ${
                isActived ? styles.activedStyle : ''
            }`}
            data-click-type="button"
            onClick={handleClick(onClick)}
        >
            {text}
        </button>
    );
};
export default ButtonLink;
